import { Location } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { AppShell } from './features/shared/shell/shell';

@Component({
  selector: 'app-root',
  imports: [AppShell, RouterOutlet],
  templateUrl: './app.component.html',
})
export class App {
  private readonly loc = inject(Location);
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  private readonly navigationEnd = toSignal(
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd))
  );

  protected readonly title = computed(() => {
    this.navigationEnd();

    let active = this.route;

    while (active.firstChild) {
      active = active.firstChild;
    }

    return active.snapshot.data['pageTitle'] ?? '';
  });

  get isOutlet(): boolean {
    return ['/ng-app-shell'].includes(this.loc.path()) === false;
  }
}
